module.exports = __webpack_public_path__ + "static/stethoscope-new-9d304da20657149dfd86e20ab2e90a94.jpg";